/*
 * File: restore-language.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-01-09 09:28:38
 * Modified By: Val Liu
 * -----
 */

import { lang } from "@root/core/i18n";
import data from "@/package.json";
const kLang = `${data.name}:lang`;

/// on app start, restore the saved language

/// restore language
let storedLanguage = localStorage.getItem(kLang);
storedLanguage && lang.set(storedLanguage);

/// save language
lang.getObservable().subscribe((lang) => {
    localStorage.setItem(kLang, lang);
});
